import getFulfilmentIds from "../../../../../../getFulfilmentIds";
import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../../../getFulfilmentType";

const getAfsLabelsCount = savedItemProducts =>
  savedItemProducts.filter(({ source, seller }) => {
    const { sourceId, sellerId } = getFulfilmentIds({ source, seller });

    return getFulfilmentType({ sourceId, sellerId }) === FULFILMENT_TYPE.AFS;
  }).length;

export default getAfsLabelsCount;
